import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
import { onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        onMounted(() => {
            const elList = document.querySelectorAll('.text-item');
            elList.forEach((el) => {
                const style = window.getComputedStyle(el, null).getPropertyValue('font-size');
                const b = parseFloat(style);
                // eslint-disable-next-line no-param-reassign
                el.innerHTML += `: font-size: ${b}px`;
            });
        });
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("div", null, [
                    _createElementVNode("ul", null, [
                        _createElementVNode("li", null, "텍스트 디자인 시스템에서는 색상값을 설정하지 않는다."),
                        _createElementVNode("li", null, "색상은 해당 위치에서 vuetify color system을 이용해서 설정한다.")
                    ])
                ], -1 /* CACHED */)),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item header-title-text" }, [
                        _createTextVNode(" header-title-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" 헤더 컨트롤러 타이틀 ")
                    ])
                ], -1 /* CACHED */)),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item sub-title-text" }, [
                        _createTextVNode(" sub-title-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" 다이얼로그 / 모달 타이틀 ")
                    ])
                ], -1 /* CACHED */)),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item contents-title-text" }, [
                        _createTextVNode(" contents-title-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" contents title / dialog subtitle ")
                    ])
                ], -1 /* CACHED */)),
                _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item contents-sub-title-text" }, [
                        _createTextVNode(" contents-sub-title-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" inputRow ")
                    ])
                ], -1 /* CACHED */)),
                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item body1-text" }, [
                        _createTextVNode(" body1-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" 일반 본문글 ")
                    ])
                ], -1 /* CACHED */)),
                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item body2-text" }, [
                        _createTextVNode(" body2-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" text field, list ")
                    ])
                ], -1 /* CACHED */)),
                _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item button-text" }, [
                        _createTextVNode(" button-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" 버튼내부 ")
                    ])
                ], -1 /* CACHED */)),
                _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createVNode(_component_v_divider),
                _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _cache[24] || (_cache[24] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-item caption-normal-text" }, [
                        _createTextVNode(" caption-normal-text "),
                        _createElementVNode("br"),
                        _createTextVNode(" 추가설명 ")
                    ])
                ], -1 /* CACHED */))
            ]));
        };
    }
});
